import AcademyArticlesPages from './subPages/academyArticles';
import AcademyCategoriesPages from './subPages/academyCategories';
import LogsPages from './subPages/logs';

const routes = [
  {
    path: '/academy_articles/*',
    canUse: [],
    Component: AcademyArticlesPages,
  },
  {
    path: '/academy_categories/*',
    canUse: [],
    Component: AcademyCategoriesPages,
  },
  {
    path: '/logs/*',
    canUse: [],
    Component: LogsPages,
  },
];

export default routes;
